import React, { Suspense } from "react";
import { Link } from "react-router-dom";
import Cards from "./Cards";
const HomeNavBar = () => {
  return (
    <div>
      <div className="row align-items-center mb-4 ">
        <div className="text-start col">
          <span className="badge bg-primary mb-2">Railsetu</span>

          <h2 className="fw-bold mb-2 " style={{ text: "rgb(247, 41, 41)" }}>
            RailSetu Projects
          </h2>

          <p className="text-secondary mb-0">
            Explore Some Dashboards From Railsetu.
          </p>
        </div>

        <div className="col-auto text-center">
          <div className="display-6 fw-bold">6</div>
          <small className="text-uppercase text-secondary">Projects</small>
        </div>
        <hr />
      </div>
      <div className="mt-2">
        <div className="row ">
          <div className="col col-md mb-2  ">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"DashBoard"}
                TextData={"click here to visit the dashboard page"}
              />
            </Suspense>
          </div>
          <div className="col col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"Block DashBoard"}
                TextData={"Click here to visit the Block dashboard page"}
              />
            </Suspense>
          </div>{" "}
          <div className="col col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"CMS Dashboard"}
                TextData={"Click here to visit the CMS page"}
              />
            </Suspense>
          </div>{" "}
          <div className="col col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"Station Map"}
                TextData={"Click here to view information about stations"}
              />
            </Suspense>
          </div>
          <div className="col col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"Clearance and Supply"}
                TextData={
                  "Click here to view information about Clearance and Supply"
                }
              />
            </Suspense>
          </div>{" "}
          <div className="col col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"Store"}
                TextData={"Click here to view information about Store"}
              />
            </Suspense>
          </div>
          <div className="col col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"Dynamic Report"}
                TextData={"Click here to view information about DataBase Table"}
              />
            </Suspense>
          </div>
          <div className="col col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"InsertData"}
                TextData={"Click here to visit the insert data page"}
              />
            </Suspense>
          </div>
          {/* <div className="col-12 col-md mb-2">
            <Suspense fallback={<div>Loading...</div>}>
              <Cards
                title={"test"}
                TextData={"Click here to visit the insert data page"}
              />
            </Suspense>
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default HomeNavBar;
